(function () {
  var root = document.querySelector('[data-csp-box-builder]');
  if (!root) return;

  var PRICES = { 6: 29.99, 12: 49.99, 24: 89.99 };
  var FRUIT_NOTES = [
    'Cherry',
    'Black Cherry',
    'Orange',
    'Grape',
    'Strawberry',
    'Lemon-Lime',
    'Lemon',
    'Lime',
    'Peach',
    'Pineapple',
    'Raspberry',
    'Blackberry',
    'Blueberry',
    'Apple',
    'Green Apple',
    'Watermelon',
    'Mango',
    'Grapefruit',
    'Banana',
    'Coconut',
    'Kiwi',
    'Lychee',
    'Melon',
  ];
  var BRAND_ALIASES = {
    'Rocket Fizz': ["Rocket Fizz", "Lester's Fixins", "Melba's Fixins"],
  };
  var collectionHandle = root.getAttribute('data-collection') || 'all-soda';
  var size = 6;
  var slots = [];
  var products = [];
  var search = '';
  var sortBy = 'featured';
  var adding = false;
  var plusIcon = (root.querySelector('[data-plus-icon]') || {}).innerHTML || '+';
  var closeIcon = (root.querySelector('[data-close-icon]') || {}).innerHTML || '×';

  var slotsWrap = root.querySelector('[data-slots-wrap]');

  var slotsEl = root.querySelector('[data-slots]');
  var slotsLabel = root.querySelector('[data-slots-label]');
  var gridEl = root.querySelector('[data-grid]');
  var statusEl = root.querySelector('[data-status]');
  var countEl = root.querySelector('[data-count]');
  var addEl = root.querySelector('[data-add]');
  var brandList = root.querySelector('[data-brand-list]');
  var fruitNotesEl = root.querySelector('[data-fruit-notes]');
  var fruitParent = root.querySelector('[data-fruit-parent]');
  var fruitInput = root.querySelector('[data-flavor="Fruit Soda"]');
  var searchEl = root.querySelector('[data-search]');
  var sortEl = root.querySelector('[data-sort]');

  function esc(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function money(n) {
    return '$' + n.toFixed(2);
  }

  function filledCount() {
    return slots.filter(Boolean).length;
  }

  function selectedFlavors() {
    return Array.prototype.map.call(root.querySelectorAll('[data-flavor]:checked'), function (input) {
      return input.getAttribute('data-flavor');
    });
  }

  function selectedFruitNotes() {
    return Array.prototype.map.call(root.querySelectorAll('[data-fruit-note]:checked'), function (input) {
      return input.getAttribute('data-fruit-note');
    });
  }

  function selectedBrands() {
    return Array.prototype.map.call(root.querySelectorAll('[data-brand]:checked'), function (input) {
      return input.value;
    });
  }

  function selectedBrandVendors() {
    var selected = selectedBrands();
    var vendors = [];
    selected.forEach(function (brand) {
      var group = BRAND_ALIASES[brand] || [brand];
      group.forEach(function (vendor) {
        if (vendors.indexOf(vendor) === -1) vendors.push(vendor);
      });
    });
    return vendors;
  }

  function tagsOf(product) {
    return (product.tags || []).map(function (tag) {
      return String(tag).toLowerCase();
    });
  }

  function hasFamily(product, flavor) {
    var tags = tagsOf(product);
    if (flavor === 'Novelty') {
      return tags.indexOf('novelty') !== -1 || tags.indexOf('novelty soda') !== -1;
    }
    return tags.indexOf(flavor.toLowerCase()) !== -1;
  }

  function notePattern(note) {
    return new RegExp('\\b' + note.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&').replace(/-/g, '[-\\s]?') + '\\b', 'i');
  }

  function hasFruitNote(product, note) {
    var tags = tagsOf(product);
    var lower = note.toLowerCase();
    if (tags.indexOf(lower) !== -1) return true;
    if (note === 'Cherry' && tags.indexOf('black cherry') !== -1) return true;
    if (note === 'Apple' && tags.indexOf('green apple') !== -1) return true;
    if (note === 'Lemon' && (tags.indexOf('lemon-lime') !== -1 || tags.indexOf('lemon lime') !== -1)) return true;
    if (note === 'Lime' && (tags.indexOf('lemon-lime') !== -1 || tags.indexOf('lemon lime') !== -1)) return true;
    return notePattern(note).test(product.title || '');
  }

  function matchesFlavor(product) {
    var flavors = selectedFlavors();
    var fruitNotes = selectedFruitNotes();
    if (!flavors.length && !fruitNotes.length) return true;

    var otherFamilies = flavors.filter(function (flavor) {
      return flavor !== 'Fruit Soda';
    });
    if (otherFamilies.some(function (flavor) {
      return hasFamily(product, flavor);
    })) {
      return true;
    }

    var isFruit = hasFamily(product, 'Fruit Soda');
    if (fruitNotes.length) {
      return isFruit && fruitNotes.some(function (note) {
        return hasFruitNote(product, note);
      });
    }
    if (flavors.indexOf('Fruit Soda') !== -1) return isFruit;
    return false;
  }

  function fold(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/['’`]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function matchesSearch(product) {
    if (!search) return true;
    return (product.searchText || '').indexOf(search) !== -1;
  }

  function visibleProducts() {
    var brands = selectedBrandVendors();
    var querying = search.length > 0;
    var list = products.filter(function (product) {
      if (brands.length && brands.indexOf(product.vendor) === -1) return false;
      if (!querying && !matchesFlavor(product)) return false;
      return matchesSearch(product);
    });
    if (sortBy === 'price-ascending') {
      list.sort(function (a, b) {
        return a.price - b.price;
      });
    } else if (sortBy === 'price-descending') {
      list.sort(function (a, b) {
        return b.price - a.price;
      });
    } else if (sortBy === 'title-ascending') {
      list.sort(function (a, b) {
        return (a.title || '').localeCompare(b.title || '');
      });
    }
    return list;
  }

  function qtyInBox(variantId) {
    return slots.filter(function (item) {
      return item && String(item.variantId) === String(variantId);
    }).length;
  }

  function renderSlots() {
    var filled = filledCount();
    if (slotsWrap) slotsWrap.hidden = filled === 0;
    slotsLabel.textContent = 'Your ' + size + '-pack';
    slotsEl.innerHTML = '';
    if (filled === 0) {
      countEl.textContent = filled + ' of ' + size;
      addEl.disabled = true;
      addEl.textContent = 'Add ' + size + ' more to checkout';
      return;
    }
    for (var i = 0; i < size; i += 1) {
      var item = slots[i];
      var li = document.createElement('li');
      li.className = 'csp-box-builder__slot' + (item ? ' is-filled' : '') + ' is-compact';
      if (item) {
        li.innerHTML =
          '<img src="' +
          esc(item.image) +
          '" alt="' +
          esc(item.title) +
          '">' +
          '<button type="button" class="csp-box-builder__slot-remove" data-remove="' +
          i +
          '" aria-label="Remove ' +
          esc(item.title) +
          '">' +
          closeIcon +
          '</button>';
      } else {
        li.innerHTML = '<span class="csp-box-builder__slot-num">' + (i + 1) + '</span>';
      }
      slotsEl.appendChild(li);
    }
    var remaining = size - filled;
    countEl.textContent = filled + ' of ' + size;
    addEl.disabled = remaining > 0 || adding;
    addEl.textContent = remaining > 0 ? 'Add ' + remaining + ' more to checkout' : 'Add ' + size + '-pack to cart · ' + money(PRICES[size]);
  }

  function renderGrid() {
    var list = visibleProducts();
    gridEl.innerHTML = '';
    if (!list.length) {
      statusEl.hidden = false;
      statusEl.textContent = 'No bottles match those filters.';
      return;
    }
    statusEl.hidden = true;
    var full = filledCount() >= size;
    list.forEach(function (product) {
      var qty = qtyInBox(product.variantId);
      var li = document.createElement('li');
      li.className = 'grid__item';
      li.innerHTML =
        '<div class="card-wrapper product-card-wrapper csp-box-builder__card' +
        (qty ? ' is-in-box' : '') +
        '">' +
        '<div class="card card--card card--media color-scheme-2 gradient">' +
        '<div class="card__inner ratio" style="--ratio-percent: 100%;">' +
        '<div class="card__media"><div class="media media--transparent">' +
        '<img src="' +
        esc(product.image) +
        '" alt="' +
        esc(product.title) +
        '" width="400" height="400" loading="lazy">' +
        '</div>' +
        (qty
          ? '<span class="csp-box-builder__qty">' + qty + '</span><button type="button" class="csp-box-builder__minus" data-remove-product="' +
            product.variantId +
            '" aria-label="Remove one ' +
            esc(product.title) +
            '">−</button>'
          : '') +
        '<button type="button" class="csp-box-builder__plus" data-add-product="' +
        product.variantId +
        '"' +
        (product.available && !full ? '' : ' disabled') +
        ' aria-label="Add ' +
        esc(product.title) +
        ' to box">' +
        plusIcon +
        '</button>' +
        '</div></div>' +
        '<div class="card__content"><div class="card__information">' +
        '<h3 class="card__heading h5"><a class="csp-box-builder__product-link" href="/products/' +
        esc(product.handle) +
        '">' +
        esc(product.title) +
        '</a></h3></div></div></div></div>';
      gridEl.appendChild(li);
    });
  }

  function firstEmpty() {
    for (var i = 0; i < size; i += 1) {
      if (!slots[i]) return i;
    }
    return -1;
  }

  var packReady = false;

  function savePack() {
    if (!packReady) return;
    try {
      sessionStorage.setItem(
        'csp-box-builder',
        JSON.stringify({
          size: size,
          variantIds: slots.map(function (item) {
            return item ? String(item.variantId) : null;
          }),
        })
      );
    } catch (e) {}
  }

  function restorePack() {
    try {
      var data = JSON.parse(sessionStorage.getItem('csp-box-builder') || 'null');
      if (!data || !data.variantIds) return;
      if (data.size) setSize(data.size);
      data.variantIds.forEach(function (id, index) {
        if (!id || index >= size) return;
        var product = products.filter(function (item) {
          return String(item.variantId) === String(id);
        })[0];
        if (product) slots[index] = product;
      });
    } catch (e) {}
  }

  function addProduct(variantId) {
    var product = products.filter(function (item) {
      return String(item.variantId) === String(variantId);
    })[0];
    var index = firstEmpty();
    if (!product || index < 0) return;
    slots[index] = product;
    renderSlots();
    renderGrid();
    savePack();
  }

  function removeSlot(index) {
    slots[index] = null;
    renderSlots();
    renderGrid();
    savePack();
  }

  function removeOne(variantId) {
    for (var i = slots.length - 1; i >= 0; i -= 1) {
      if (slots[i] && String(slots[i].variantId) === String(variantId)) {
        slots[i] = null;
        break;
      }
    }
    renderSlots();
    renderGrid();
    savePack();
  }

  function setSize(next) {
    next = Number(next);
    var kept = slots.filter(Boolean);
    if (kept.length > next) kept = kept.slice(0, next);
    size = next;
    slots = [];
    for (var i = 0; i < size; i += 1) slots[i] = kept[i] || null;
    root.querySelectorAll('[data-size]').forEach(function (btn) {
      var on = Number(btn.getAttribute('data-size')) === size;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    renderSlots();
    renderGrid();
    savePack();
  }

  function cartItems() {
    var qty = {};
    slots.filter(Boolean).forEach(function (item) {
      var id = String(item.variantId);
      qty[id] = (qty[id] || 0) + 1;
    });
    return Object.keys(qty).map(function (id) {
      return { id: Number(id), quantity: qty[id] };
    });
  }

  function jsonFetch(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) throw new Error(url);
      return res.json();
    });
  }

  function addBoxToCart() {
    if (filledCount() !== size || adding) return;
    adding = true;
    addEl.disabled = true;
    addEl.textContent = 'Adding…';
    jsonFetch('/cart.js')
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (item.product_type === 'Soda') updates[item.variant_id] = 0;
        });
        return Object.keys(updates).length
          ? jsonFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates }),
            })
          : Promise.resolve();
      })
      .then(function () {
        return jsonFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems() }),
        });
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        adding = false;
        renderSlots();
        addEl.textContent = 'Could not add box. Try again.';
      });
  }

  function normalizeProduct(raw) {
    if (raw.product_type !== 'Soda') return null;
    var variant =
      (raw.variants || []).filter(function (item) {
        return item.available !== false;
      })[0] || raw.variants[0];
    if (!variant) return null;
    var image = '';
    if (raw.featured_image) image = raw.featured_image.src || raw.featured_image;
    else if (raw.images && raw.images[0]) image = raw.images[0].src || raw.images[0];
    if (image && image.indexOf('http') === 0) {
      image = image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_800x$1$2');
    }
    return {
      id: raw.id,
      handle: raw.handle,
      title: raw.title,
      vendor: raw.vendor || '',
      tags: raw.tags || [],
      variantId: variant.id,
      price: Number(variant.price) || 0,
      available: variant.available !== false,
      image: image,
      searchText: fold(
        [raw.title, raw.vendor, raw.handle, (raw.tags || []).join(' '), raw.body_html].join(' ')
      ),
    };
  }

  function checkboxMarkup(attrs, label) {
    var square = root.querySelector('[data-flavor-list] .facet-checkbox > svg');
    var check = root.querySelector('[data-flavor-list] .facet-checkbox .svg-wrapper');
    return (
      '<li class="list-menu__item facets__item"><label class="facets__label facet-checkbox">' +
      '<input type="checkbox" class="csp-box-builder__check" ' +
      attrs +
      '>' +
      (square ? square.outerHTML : '') +
      (check ? check.outerHTML : '') +
      '<span class="facet-checkbox__text"><span class="facet-checkbox__text-label">' +
      esc(label) +
      '</span></span></label></li>'
    );
  }

  function fillBrands() {
    if (!brandList) return;
    var vendors = [];
    products.forEach(function (product) {
      if (product.vendor && vendors.indexOf(product.vendor) === -1) vendors.push(product.vendor);
    });
    vendors.sort(function (a, b) {
      return a.localeCompare(b);
    });
    brandList.innerHTML = vendors
      .map(function (vendor) {
        return checkboxMarkup('data-brand value="' + esc(vendor) + '"', vendor);
      })
      .join('');
  }

  function fillFruitNotes() {
    if (!fruitNotesEl) return;
    var fruitProducts = products.filter(function (product) {
      return hasFamily(product, 'Fruit Soda');
    });
    fruitNotesEl.innerHTML = FRUIT_NOTES.filter(function (note) {
      return fruitProducts.some(function (product) {
        return hasFruitNote(product, note);
      });
    })
      .map(function (note) {
        return checkboxMarkup('data-fruit-note="' + esc(note) + '"', note);
      })
      .join('');
  }

  function syncFruitNest() {
    if (!fruitParent || !fruitInput) return;
    var notes = selectedFruitNotes();
    if (notes.length && !fruitInput.checked) fruitInput.checked = true;
    fruitParent.classList.toggle('is-open', fruitInput.checked || notes.length > 0);
  }

  function loadPage(page) {
    return jsonFetch(
      '/collections/' + collectionHandle + '/products.json?limit=250&page=' + page + '&sort_by=best-selling'
    ).then(function (data) {
      return data.products || [];
    });
  }

  function loadProducts() {
    products = [];
    function next(page) {
      return loadPage(page).then(function (batch) {
        products = products.concat(batch.map(normalizeProduct).filter(Boolean));
        if (batch.length === 250 && page < 8) return next(page + 1);
      });
    }
    return next(1);
  }

  root.addEventListener('click', function (event) {
    var sizeBtn = event.target.closest('[data-size]');
    if (sizeBtn) {
      setSize(sizeBtn.getAttribute('data-size'));
      return;
    }
    var removeBtn = event.target.closest('[data-remove]');
    if (removeBtn) {
      removeSlot(Number(removeBtn.getAttribute('data-remove')));
      return;
    }
    /* REGRESSION 2026-08-25: handle plus/minus BEFORE the product title link.
       Dawn .card__heading a::after covers the card; a click on plus was hitting
       that overlay, this handler returned early, and the browser opened the
       product page. CSS kills the overlay; this order is the JS backup. */
    var addProductBtn = event.target.closest('[data-add-product]');
    if (addProductBtn) {
      event.preventDefault();
      event.stopPropagation();
      if (!addProductBtn.disabled) addProduct(addProductBtn.getAttribute('data-add-product'));
      return;
    }
    var removeProduct = event.target.closest('[data-remove-product]');
    if (removeProduct) {
      event.preventDefault();
      event.stopPropagation();
      removeOne(removeProduct.getAttribute('data-remove-product'));
      return;
    }
    if (event.target.closest('.csp-box-builder__product-link')) return;
    var addBtn = event.target.closest('.csp-box-builder__card');
    if (addBtn && addBtn.closest('[data-grid]')) {
      var target = addBtn.querySelector('[data-add-product]');
      if (target && !target.disabled) addProduct(target.getAttribute('data-add-product'));
      return;
    }
    if (event.target.closest('[data-add]')) addBoxToCart();
  });

  root.addEventListener('change', function (event) {
    if (event.target.matches('[data-flavor="Fruit Soda"]')) {
      if (!event.target.checked) {
        root.querySelectorAll('[data-fruit-note]').forEach(function (input) {
          input.checked = false;
        });
      }
      syncFruitNest();
    }
    if (event.target.matches('[data-fruit-note]')) syncFruitNest();
    if (event.target.matches('[data-flavor], [data-brand], [data-fruit-note]')) renderGrid();
    if (event.target.matches('[data-sort]')) {
      sortBy = event.target.value || 'featured';
      renderGrid();
    }
  });

  if (searchEl) {
    searchEl.addEventListener('input', function () {
      search = fold(searchEl.value);
      root.classList.toggle('is-searching', search.length > 0);
      renderGrid();
    });
    searchEl.addEventListener('focus', function () {
      root.classList.add('is-search-open');
    });
    searchEl.addEventListener('blur', function () {
      if (!searchEl.value) root.classList.remove('is-search-open');
    });
  }

  function loadRank() {
    var url = root.getAttribute('data-rank-url');
    if (!url) return Promise.resolve([]);
    return jsonFetch(url)
      .then(function (data) {
        return (data && data.handles) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function applyRank(handles) {
    if (!handles || !handles.length) return;
    var index = {};
    handles.forEach(function (handle, i) {
      index[handle] = i;
    });
    products.sort(function (a, b) {
      var ra = Object.prototype.hasOwnProperty.call(index, a.handle) ? index[a.handle] : null;
      var rb = Object.prototype.hasOwnProperty.call(index, b.handle) ? index[b.handle] : null;
      if (ra == null && rb == null) return a.title.localeCompare(b.title);
      if (ra == null) return 1;
      if (rb == null) return -1;
      return ra - rb;
    });
  }

  setSize(6);
  Promise.all([loadProducts(), loadRank()])
    .then(function (results) {
      applyRank(results[1]);
      statusEl.hidden = true;
      fillBrands();
      fillFruitNotes();
      restorePack();
      packReady = true;
      renderSlots();
      renderGrid();
      var soda = new URLSearchParams(window.location.search).get('soda');
      if (!soda) return;
      var match = products.filter(function (item) {
        return item.handle === soda;
      })[0];
      if (match) addProduct(String(match.variantId));
    })
    .catch(function () {
      statusEl.hidden = false;
      statusEl.textContent = 'Could not load bottles. Refresh the page.';
    });
})();
